import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { BadInputError } from '@digibricks/core';
export var InvalidNumberOfSubmissionError = /*#__PURE__*/function (_BadInputError) {
  _inherits(InvalidNumberOfSubmissionError, _BadInputError);

  var _super = _createSuper(InvalidNumberOfSubmissionError);

  function InvalidNumberOfSubmissionError() {
    _classCallCheck(this, InvalidNumberOfSubmissionError);

    return _super.call(this, new Error('InvalidNumberOfSubmissionError'));
  }

  return InvalidNumberOfSubmissionError;
}(BadInputError);
export var InvalidDurationError = /*#__PURE__*/function (_BadInputError2) {
  _inherits(InvalidDurationError, _BadInputError2);

  var _super2 = _createSuper(InvalidDurationError);

  function InvalidDurationError() {
    _classCallCheck(this, InvalidDurationError);

    return _super2.call(this, new Error('InvalidDurationError'));
  }

  return InvalidDurationError;
}(BadInputError);
export var InvalidTitleLengthError = /*#__PURE__*/function (_BadInputError3) {
  _inherits(InvalidTitleLengthError, _BadInputError3);

  var _super3 = _createSuper(InvalidTitleLengthError);

  function InvalidTitleLengthError() {
    _classCallCheck(this, InvalidTitleLengthError);

    return _super3.call(this, new Error('InvalidTitleLengthError'));
  }

  return InvalidTitleLengthError;
}(BadInputError);